import { useEffect, useState, useMemo } from 'react'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { getOutcomeColumns } from './AccountingFields'
import Loading from '../../common/Loading'
import { Box } from '@mui/material'

const ListOutcome = () => {
  const [suppliers, setSuppliers] = useState([])
  const [customers, setCustomers] = useState([])
  const { user } = useAuth()
  const userRight = useOutletContext()

  const columns = useMemo(() => {
    return getOutcomeColumns({ suppliers, customers })
  }, [suppliers])

  const options = useMemo(
    () => ({
      objectType: 'outcomes',
      accessRight: userRight,
      objectFilter: () => ({ company_id: user.company_id }),
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer'
        }
      },
      showTotal: { display: true, label: 'Montant total', field: 'totalAmount', type: 'currency' },
      isExpand: false,
      columns
    }),
    [userRight, user.company_id, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'outcomes',
      title: 'Décaissements',
      accessRight: userRight,
      actions: {
        add: true
      },
      isFilter: true,
      columns: options.columns,
      columnVisibility: true
    }),
    [userRight, options]
  )

  useEffect(() => {
    const loadData = async () => {
      try {
        const [suppliersRes, customersRes] = await Promise.all([
          getObjectsWithFilter('suppliers', {
            company_id: user.company_id
          }),
          getObjectsWithFilter('customers', { company_id: user.company_id })
        ])
        setSuppliers(Array.isArray(suppliersRes.data?.suppliers) ? suppliersRes.data.suppliers : [])
        setCustomers(Array.isArray(customersRes.data?.customers) ? customersRes.data.customers : [])
      } catch {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }
    loadData()
  }, [user.company_id])

  if (!columns.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )
  return <ListModule options={options} toolbar={toolbar} />
}

export default ListOutcome
